const sizeFilter = (value, record) => {
    //console.log(value);
    //console.log(record);
    return record.size.indexOf(value) === 0;
};


export default sizeFilter;
